export function createSingleFlight() {
  const pending = new Map();
  return (key, operation) => {
    const normalized = String(key);
    if (pending.has(normalized)) return pending.get(normalized);
    const promise = Promise.resolve().then(operation).finally(() => {
      if (pending.get(normalized) === promise) pending.delete(normalized);
    });
    pending.set(normalized, promise);
    return promise;
  };
}
